import { DeliveryType } from "../schema/DeliveryType.js";

const pplDeliveryTypes = [DeliveryType.DeliveryToParcelShop, DeliveryType.DeliveryToParcelBox] as const;
export type PplDeliveryType = (typeof pplDeliveryTypes)[number];

export function isPplDeliveryType(deliveryType: DeliveryType | null | undefined): deliveryType is PplDeliveryType {
	return pplDeliveryTypes.includes(deliveryType as PplDeliveryType);
}
